// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenomePromote_GenomePromoteForm__j12kt {
  max-width: 1100px;
  margin:0 auto;
  margin-top: 50px;
  
}`, "",{"version":3,"sources":["webpack://./src/scene-d/Gene/GenePromote/GenomePromote.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;;AAElB","sourcesContent":[".GenomePromoteForm {\n  max-width: 1100px;\n  margin:0 auto;\n  margin-top: 50px;\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GenomePromoteForm": `GenomePromote_GenomePromoteForm__j12kt`
};
export default ___CSS_LOADER_EXPORT___;
